import React, { useMemo } from "react";
import styled from "styled-components";

import { getUsageCellHref } from "./getUsageCellHref";
import { WithUsagesData } from "./useUsagesCells";

export interface UsageCellLinkProps extends React.HTMLAttributes<HTMLAnchorElement> {
  cell: WithUsagesData["cells"][number];
}

const UsageCellLink_ = React.memo(
  React.forwardRef<HTMLAnchorElement, UsageCellLinkProps>(function CellLink(
    { cell, ...rest },
    ref,
  ) {
    const href = useMemo(() => getUsageCellHref({ cell }), [cell]);

    return <a ref={ref} href={href} {...rest} />;
  }),
);

export const UsageCellLink = styled(UsageCellLink_)`
  color: inherit;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow-wrap: normal;
  &:hover {
    color: inherit;
  }
  &:visited {
    color: inherit;
  }
`;
